import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/Generallogo.png';
import { BASE_URL } from '../Utils/Function';
import { FaLock, FaUserShield, FaEye, FaEyeSlash } from 'react-icons/fa';
import BackgroundEffect from '../components/BackgroundEffect';

const AdminLogin = () => {
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        try {
            const response = await axios.post(`${BASE_URL}/users/login.php`, {
                mobile_no: phone,
                user_password: password
            });

            if (response.data.status === 200) {
                const userData = response.data.data;
                if (userData.role === "2" || userData.role === 2) {
                    localStorage.setItem('adminUser', JSON.stringify(userData));
                    navigate('/admin/dashboard');
                } else {
                    setError('Access Denied: Administrative privileges required');
                }
            } else {
                setError(response.data.message || 'Invalid credentials');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'System authentication failed');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="admin-login-wrapper">
            <BackgroundEffect />
            <div className="admin-login-card">
                <div className="text-center mb-5">
                    <span className="admin-logo-text" style={{ 
                        fontWeight: '700', 
                        color: '#fff', 
                        letterSpacing: '4px',
                        fontSize: 'clamp(1.2rem, 6vw, 2rem)',
                        textTransform: 'uppercase',
                        fontFamily: 'Outfit, sans-serif',
                        display: 'block',
                        marginBottom: '6px',
                        whiteSpace: 'nowrap'
                    }}>
                        AL WASEEQ DESIGN
                    </span>
                    <span className="admin-tagline" style={{
                        fontSize: '0.7rem',
                        color: '#fff',
                        letterSpacing: '3px',
                        fontWeight: '300',
                        textTransform: 'uppercase',
                        opacity: '0.6',
                        display: 'block',
                        marginBottom: '25px'
                    }}>
                        We Craft Your Dream World
                    </span>
                    <div className="admin-badge">
                        <FaUserShield className="me-2 text-secondary-color" />
                        SECURE ADMINISTRATIVE GATEWAY
                    </div>
                </div>

                <form onSubmit={handleLogin}>
                    <div className="mb-4">
                        <label className="admin-label mb-2">MOBILE ACCESS ID</label>
                        <div className="auth-input-wrapper">
                            <input
                                type="tel"
                                className="auth-input"
                                placeholder="Enter your mobile number"
                                value={phone}
                                onChange={(e) => {
                                    const val = e.target.value.replace(/\D/g, '');
                                    if (val.length <= 10) setPhone(val);
                                }}
                                required
                            />
                        </div>
                    </div>

                    <div className="mb-5">
                        <label className="admin-label mb-2">CREDENTIAL SECURITY KEY</label>
                        <div className="auth-input-wrapper">
                            <input
                                type={showPassword ? "text" : "password"}
                                className="auth-input"
                                placeholder="Enter your password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <button
                                type="button"
                                className="password-toggle-btn"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                    </div>

                    {error && <div className="admin-error-box mb-4">{error}</div>}

                    <button
                        type="submit"
                        className="btn-admin-submit w-100 py-3 mb-2"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <span className="spinner-border spinner-border-sm me-2"></span>
                        ) : (
                            <FaLock className="me-2" />
                        )}
                        AUTHORIZE ACCESS
                    </button>
                    <div className="text-center">
                        <span className="system-status-indicator">SYSTEM STATUS: OPTIMAL</span>
                    </div>
                </form>
            </div>

            <style>{`
                .admin-login-wrapper {
                    min-height: 100vh;
                    background: radial-gradient(circle at center, #111 0%, #000 100%);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 20px;
                    position: relative;
                    overflow: hidden;
                }

                .admin-login-card {
                    width: 100%;
                    max-width: 440px;
                    background: rgba(20, 20, 20, 0.6);
                    backdrop-filter: blur(25px);
                    border: 1px solid rgba(197, 160, 89, 0.1);
                    padding: 60px 45px;
                    border-radius: 4px;
                    box-shadow: 0 40px 100px rgba(0, 0, 0, 0.8);
                    z-index: 10;
                }

                .admin-label {
                    color: var(--secondary-color);
                    font-size: 0.65rem;
                    letter-spacing: 3px;
                    font-weight: 600;
                    text-transform: uppercase;
                    opacity: 0.8;
                }

                .admin-badge {
                    display: inline-flex;
                    align-items: center;
                    padding: 6px 16px;
                    background: rgba(197, 160, 89, 0.05);
                    color: #fff;
                    font-size: 0.6rem;
                    letter-spacing: 3px;
                    border: 1px solid rgba(197, 160, 89, 0.15);
                    border-radius: 2px;
                    font-weight: 500;
                    text-transform: uppercase;
                }

                .auth-input-wrapper {
                    display: flex;
                    align-items: center;
                    background: rgba(0,0,0,0.3);
                    border: 1px solid rgba(255,255,255,0.1);
                    border-radius: 2px;
                    overflow: hidden;
                }

                .auth-input {
                    flex-grow: 1;
                    background: transparent;
                    border: none;
                    color: white;
                    padding: 12px 15px;
                    font-size: 1rem;
                    outline: none;
                }

                .auth-input::placeholder {
                    color: rgba(255,255,255,0.4);
                }

                .auth-input:focus {
                    box-shadow: none;
                }

                .auth-input-wrapper:focus-within {
                    border-color: var(--secondary-color);
                }

                .phone-prefix {
                    padding: 12px 15px;
                    color: rgba(255,255,255,0.6);
                    border-right: 1px solid rgba(255,255,255,0.1);
                    font-size: 1rem;
                }

                .password-toggle-btn {
                    background: transparent;
                    border: none;
                    color: rgba(255,255,255,0.6);
                    padding: 0 15px;
                    cursor: pointer;
                    font-size: 1rem;
                    transition: color 0.2s ease;
                }

                .password-toggle-btn:hover {
                    color: var(--secondary-color);
                }

                .btn-admin-submit {
                    background: var(--secondary-color);
                    border: 1px solid var(--secondary-color);
                    color: #000;
                    font-weight: 700;
                    letter-spacing: 3px;
                    font-size: 0.75rem;
                    border-radius: 2px;
                    transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
                    text-transform: uppercase;
                }

                .btn-admin-submit:hover {
                    background: transparent;
                    color: var(--secondary-color);
                    transform: translateY(-2px);
                    box-shadow: 0 10px 30px rgba(197, 160, 89, 0.15);
                }

                .admin-error-box {
                    background: rgba(220, 53, 69, 0.05);
                    border-left: 2px solid #dc3545;
                    color: #dc3545;
                    padding: 12px 15px;
                    font-size: 0.75rem;
                    letter-spacing: 1px;
                }

                .system-status-indicator {
                    font-size: 0.55rem;
                    color: rgba(255,255,255,0.3);
                    letter-spacing: 2px;
                    font-weight: 500;
                }

                .system-status-indicator::before {
                    content: '';
                    display: inline-block;
                    width: 6px;
                    height: 6px;
                    background: #28a745;
                    border-radius: 50%;
                    margin-right: 8px;
                    box-shadow: 0 0 5px #28a745;
                }
            `}</style>
        </div>
    );
};

export default AdminLogin;
